import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-account-activity',
  standalone: false,
  
  templateUrl: './sales-account-activity.component.html',
  styles: ``
})
export class SalesAccountActivityComponent {

}
